'use client'

import {useRef} from 'react'
import HeaderContext from './HeaderContext'
import {createHeaderStore} from '../stores/useHeaderStore'

const HeaderContextProvider = ({children, value}) => {
	const storeRef = useRef<any>()

	if (!storeRef.current) {
		storeRef.current = createHeaderStore(value)
	}

	return (
		<HeaderContext.Provider value={storeRef.current}>
			{children}
		</HeaderContext.Provider>
	)
}

export default HeaderContextProvider
